import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item"];
  static values = {
    id: String,
  };

  markAsRead() {
    fetch(`/notifications/${this.idValue}/mark_as_read`, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
        Accept: "application/json",
      },
    }).then(() => {
      this.itemTarget.classList.remove("bg-indigo-50", "dark:bg-indigo-500/10");
    });
  }
}
